import { Button, Stack } from "@mui/material";

export function Reports() {
  return <Stack>
    <Button fullWidth href="/reports/txnReport">Transaction Report</Button>
  </Stack>
}